import { Routes } from '@angular/router';
import { ChoosePlanInfoComponent } from '@shared/choose-plan-info/choose-plan-info.component';
import { EmptyComponent } from './empty/empty.component';
import { LoginDoctorComponent } from './login/doctor/login-doctor.component';
import { LogoutComponent } from './logout/logout.component';
import { MainConcernComponent } from './main-concern/main-concern.component';
import { HelpComponent } from './help/help.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { UserViewComponent } from './user/user-view/user-view.component';
import { ArticleComponent } from './article/article.component';
import { OnboardingLanguageComponent } from './onboarding-language/onboarding-language.component';
import { IframeComponent } from './iframe/iframe.component';
import { NoticeComponent } from './notice/notice.component';
import { VideoComponent } from './video/video.component';
import { ReminderFullPageComponent } from './reminder';
import { ProductCartComponent } from './cart/cart.component';
import { QuizGameComponent } from './quiz-game/quiz-game.component';
import { ReportComponent } from './report/report.component';
import { authenticationGuard } from './guards/authentication.guard';
import { onboardingGuard } from './guards/onboarding.guard';
import { shopGuard } from './guards/shop.guard';
import { npsFeedbackRevampGuard } from './guards/nps-feedback-revamp.guard';
import { TestimonialsNewComponent } from './testimonial/testimonials-new/testimonials-new.component';
import { TestimonialsDescComponent } from './testimonial/testimonials-description/testimonials-description.component';
import { UserCheckoutComponent } from './user-checkout/user-checkout.component';
import { TestimonialCaseStudiesInfoComponent } from './testimonial/testimonial-case-studies-info/testimonial-case-studies-info.component';
import { UserNotificationComponent } from './user-notification/user-notification.component';
import { UserRegimenDoctorComponent } from './user-regimen/user-regimen-doctor/user-regimen-doctor.component';
import { UserRegimenServicesComponent } from './user-regimen/user-regimen-services/user-regimen-services.component';
import {
  CheckupCaptureComponent, CheckupListComponent,
  CheckupPhotoInstructionComponent, CheckupViewContainerComponent,
  SelectCheckupTypeComponent,

} from './instant-checkup/components';
import { UserAddressListComponent } from './user-address/user-address-list/user-address-list.component';
import { UserAddressEditComponent } from './user-address/user-address-edit/user-address-edit.component';
import { UserFollowupReportComponent } from './user-followup-report/user-followup-report.component';
import { UserOrderListComponent } from './user-order/user-order-list/user-order-list.component';
import { UserOrderReorderComponent } from './user-order/user-order-reorder/user-order-reorder.component';
import { UserOrderSuccessComponent } from './user-order/user-order-success/user-order-success.component';
import { UserOrderFailureComponent } from './user-order/user-order-failure/user-order-failure.component';
import { UserOrderAddonComponent } from './user-order/user-order-addon/user-order-addon.component';
import { UserOrderPaymentComponent } from './user-order/user-order-payment/user-order-payment.component';
import { UserOrderViewComponent } from './user-order/user-order-view/user-order-view.component';
import { UserPrescriptionViewComponent } from './user-prescription/user-prescription-view.component';
import { UserReferComponent } from './user-refer/user-refer.component';
import { UserWalletViewComponent } from './user-wallet/user-wallet-view/user-wallet-view.component';
import { UserWalletTransactionsComponent } from './user-wallet/user-wallet-transactions/user-wallet-transactions.component';
import { UserProfileComponent } from './user-profile/user-profile/user-profile.component';
import { UserProfileEditComponent } from './user-profile/user-profile-edit/user-profile-edit.component';
import { UserCheckupComponent } from './user-checkup/user-checkup.component';
import { RegimenProductsDetailComponent } from './user-regimen/regimen-products-detail/regimen-products-detail.component';
import { regimenProductsDetailGuard } from './user-regimen/regimen-products-detail.guard';
import { UserRegimenProductsViewComponent } from './user-regimen/user-regimen-products-view/user-regimen-products-view.component';
import { RecentlyViewedProductsComponent } from '@shared/recently-viewed-products/recently-viewed-products.component';
import { ClinicalTechnologyComponent } from './clinical-technology/clinical-technology.component';
import { userRouteRedirectGuard } from './guards/user-route-redirect.guard';
import { regimenRoutesRedirectGuard } from './guards/regimen-routes-redirect.guard';
import { checkoutGuard } from './guards/checkout.guard';
import { UserProductsViewComponent } from './user/user-view/user-view-instructions/user-products-view/user-products-view.component';
import { MoneybackGuaranteePageComponent } from './moneyback-guarantee/moneyback-guarantee-page.component';
import { SubmitDefaultAnswersComponent } from './submit-default-answers/submit-default-answers.component';
import { ChangeLanguagePageComponent } from './change-language/change-language.component';
import { TrustInfoPageComponent } from './trust-info-page/trust-info-page.component';
import { ReviewOrderComponent } from './review-order/review-order.component';
import { UnpaidUserShopComponent } from './shop/unpaid-user-shop/unpaid-user-shop.component';
import { RegimenShellComponent } from './user/user-view/user-regimen/regimen-view-shell/regimen-view-shell.component';
import { regimenNewRoutesGuard } from './guards/regimen-new-routes.guard';
import { regimenViewStateGuard } from './guards/regimen-view-state.guard';
import { regimenOthersMatch } from './guards/regimen-others-match.guard';
import { RegimenInstructionComponent } from '@shared/regimen-instruction/regimen-instruction.component';
import { UserViewRegimenEmptyComponent } from './user/user-view/user-regimen/user-view-regimen-empty/user-view-regimen-empty.component';
import { UserViewRegimenPreparationComponent } from './user/user-view/user-regimen/user-view-regimen-preparation/user-view-regimen-preparation.component';
import { UserViewRegimenUnpaidComponent } from './user/user-view/user-regimen/user-view-regimen-unpaid/user-view-regimen-unpaid.component';
import { ConsultationSessionChatComponent } from './user/user-view/user-regimen/consultation-session-chat/consultation-session-chat.component';
import { UserViewInstructionsComponent } from './user/user-view/user-view-instructions/user-view-instructions.component';
import { ConsultationQuizComponent } from './consultation-quiz/consultation-quiz.component';
import { consultationQuizExitGuard, consultationQuizGuard, regimenChatToConsultationQuizGuard } from './guards/consultation-quiz.guard';

const AppRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [authenticationGuard],
    redirectTo: '/user?tab=home&init=true',
  },
  {
    path: 'language',
    component: OnboardingLanguageComponent,
    data: { openedPage: { pageName: 'LanguagePage' } },
  },
  {
    path: 'logout',
    component: LogoutComponent,
  },
  {
    path: 'trust-info',
    component: TrustInfoPageComponent,
    data: { openedPage: { pageName: 'TrustInfo' } },
  },
  {
    path: 'cart',
    canActivate: [authenticationGuard, onboardingGuard],
    component: ProductCartComponent,
    data: { openedPage: { pageName: 'CartPage' } },
  },
  {
    path: 'notice',
    canActivate: [authenticationGuard, onboardingGuard],
    component: NoticeComponent,
    data: { openedPage: { pageName: 'NoticePage' } },
  },
  {
    path: 'video',
    canActivate: [authenticationGuard, onboardingGuard],
    component: VideoComponent,
  },
  {
    path: 'mainConcern',
    canActivate: [authenticationGuard],
    component: MainConcernComponent,
    data: { openedPage: { pageName: 'MainConcernPage' } },
  },
  {
    path: 'progress/:id',
    canActivate: [authenticationGuard, onboardingGuard],
    redirectTo: '/user/report/:id',
  },
  {
    path: 'report',
    canActivate: [authenticationGuard, onboardingGuard],
    component: ReportComponent,
    data: { openedPage: { pageName: 'ReportPage' } },
  },
  {
    path: 'help',
    data: {
      openedPage: {
        pageName: 'HelpPage',
      },
    },
    canActivate: [authenticationGuard, onboardingGuard],
    component: HelpComponent,
  },
  {
    path: 'quiz-game',
    canActivate: [authenticationGuard, onboardingGuard],
    component: QuizGameComponent,
    data: { openedPage: { pageName: 'QuizPage' } },
  },
  {
    path: 'feedback',
    canMatch: [npsFeedbackRevampGuard],
    canActivate: [authenticationGuard, onboardingGuard],
    loadComponent: () => import('./feedback-revamp/feedback-revamp.component').then(m => m.FeedbackRevampComponent),
    data: { openedPage: { pageName: 'FeedbackPage' } },
  },
  {
    path: 'feedback/:category',
    canMatch: [npsFeedbackRevampGuard],
    canActivate: [authenticationGuard, onboardingGuard],
    loadComponent: () => import('./feedback-revamp/feedback-revamp.component').then(m => m.FeedbackRevampComponent),
    data: { openedPage: { pageName: 'FeedbackCategoryPage' } },
  },
  {
    path: 'feedback',
    canActivate: [authenticationGuard, onboardingGuard],
    component: FeedbackComponent,
    data: { openedPage: { pageName: 'FeedbackPage' } },
  },
  {
    path: 'feedback/:category',
    canActivate: [authenticationGuard, onboardingGuard],
    component: FeedbackComponent,
    data: { openedPage: { pageName: 'FeedbackCategoryPage' } },
  },
  {
    path: 'login/doctor',
    component: LoginDoctorComponent,
    data: { openedPage: { pageName: 'DoctorLoginPage' } },
  },
  {
    path: 'empty',
    canActivate: [authenticationGuard, onboardingGuard],
    component: EmptyComponent,
  },
  {
    path: 'addonProduct/:id',
    canActivate: [authenticationGuard, onboardingGuard],
    component: ArticleComponent,
    data: { openedPage: { pageName: 'AddOnProductArticlePage' } },
  },
  {
    path: 'article/:id',
    canActivate: [authenticationGuard, onboardingGuard],
    component: ArticleComponent,
    data: { openedPage: { pageName: 'ArticleIdPage' } },
  },
  {
    path: 'iframe',
    component: IframeComponent,
  },
  {
    path: 'regimen',
    canActivate: [authenticationGuard, onboardingGuard],
    data: { openedPage: { pageName: 'RegimenPage' } },
    children: [
      {
        path: '',
        component: UserViewComponent,
        pathMatch: 'full',
      },
      {
        path: 'products',
        canActivate: [regimenProductsDetailGuard],
        component: UserRegimenProductsViewComponent,
        data: { openedPage: { pageName: 'RegimenProductPage' } } },
      {
        path: 'revamp-products',
        component: RegimenProductsDetailComponent,
        data: { openedPage: { pageName: 'RegimenRevampProductPage' } } },
      {
        path: 'doctor',
        component: UserRegimenDoctorComponent,
        data: { openedPage: { pageName: 'RegimenDoctorPage' } } },
      { path: 'services', component: UserRegimenServicesComponent, data: { openedPage: { pageName: 'RegimenServicePage' } } },
      { path: 'plan-info', component: ChoosePlanInfoComponent, data: { openedPage: { pageName: 'RegimenPlainInfoPage' } } },
      {
        path: '',
        component: RegimenShellComponent,
        canActivate: [regimenNewRoutesGuard],
        canActivateChild: [regimenViewStateGuard],
        children: [
          // canMatch: dispatch ?class=OTHERS to UserViewInstructionsComponent; FACE/HAIR fall through to RegimenInstructionComponent.
          { path: 'instructions', canMatch: [regimenOthersMatch], component: UserViewInstructionsComponent },
          { path: 'instructions', component: RegimenInstructionComponent },
          { path: 'empty', component: UserViewRegimenEmptyComponent },
          { path: 'preparation', component: UserViewRegimenPreparationComponent },
          { path: 'unpaid', component: UserViewRegimenUnpaidComponent },
          {
            path: 'chat',
            canActivate: [regimenChatToConsultationQuizGuard],
            runGuardsAndResolvers: 'paramsOrQueryParamsChange',
            component: ConsultationSessionChatComponent,
          },
        ],
      },
    ],
  },
  {
    path: 'consultation-quiz/:id',
    canActivate: [authenticationGuard, onboardingGuard, consultationQuizGuard],
    canDeactivate: [consultationQuizExitGuard],
    component: ConsultationQuizComponent,
    data: { openedPage: { pageName: 'ConsultationQuizPage' } },
  },
  {
    path: 'products',
    canActivate: [authenticationGuard, onboardingGuard],
    component: UserProductsViewComponent,
    data: { openedPage: { pageName: 'productDetailedInstructionsPage' } } },
  {
    path: 'explore',
    canActivate: [authenticationGuard, onboardingGuard],
    component: UserViewComponent,
    pathMatch: 'full',
  },
  {
    path: 'shop',
    canActivate: [authenticationGuard, onboardingGuard, shopGuard],
    component: UserViewComponent,
    pathMatch: 'full',
  },
  {
    path: 'unpaid-user-shop',
    canActivate: [authenticationGuard, onboardingGuard],
    component: UnpaidUserShopComponent,
    pathMatch: 'full',
  },
  {
    path: 'user',
    canActivate: [authenticationGuard, onboardingGuard],
    children: [
      {
        path: '',
        canActivate: [userRouteRedirectGuard],
        component: UserViewComponent,
        pathMatch: 'full',
      },
      { path: 'testimonialsNew', component: TestimonialsNewComponent, data: { openedPage: { pageName: 'TestimonialNewPage' } } },
      { path: 'testimonialsNew/:type/:testimonialId',
        component: TestimonialsDescComponent,
        data: { openedPage: { pageName: 'TestimonialNewIdPage' } } },
      { path: 'caseStudies/:caseStudyId',
        component: TestimonialCaseStudiesInfoComponent,
        data: { openedPage: { pageName: 'CaseStudyPage' } } },
      { path: 'checkout', canActivate: [checkoutGuard], component: UserCheckoutComponent, data: { openedPage: { pageName: 'CheckoutPage' } } },
      { path: 'followups', component: UserCheckupComponent, data: { openedPage: { pageName: 'FollowUpPage' } } },
      { path: 'checkup', component: UserCheckupComponent, data: { openedPage: { pageName: 'CheckUpPage' } } },
      { path: 'notifications', component: UserNotificationComponent, data: { openedPage: { pageName: 'NotificationPage' } } },
      { path: 'followup/reminder', component: UserCheckupComponent, data: { openedPage: { pageName: 'FollowupReminderPage' } } },
      {
        path: 'regimen',
        canActivate: [regimenRoutesRedirectGuard],
        data: { openedPage: { pageName: 'RegimenPage' } },
        children: [
          { path: 'products',
            canActivate: [regimenRoutesRedirectGuard, regimenProductsDetailGuard],
            component: UserRegimenProductsViewComponent,
            data: { openedPage: { pageName: 'RegimenProductPage' } } },
          { path: 'revamp-products',
            canActivate: [regimenRoutesRedirectGuard],
            component: RegimenProductsDetailComponent,
            data: { openedPage: { pageName: 'RegimenRevampProductPage' } } },
          { path: 'doctor',
            canActivate: [regimenRoutesRedirectGuard],
            component: UserRegimenDoctorComponent,
            data: { openedPage: { pageName: 'RegimenDoctorPage' } } },
          { path: 'services',
            component: UserRegimenServicesComponent,
            canActivate: [regimenRoutesRedirectGuard],
            data: { openedPage: { pageName: 'RegimenServicePage' } } },
          { path: 'plan-info',
            component: ChoosePlanInfoComponent,
            canActivate: [regimenRoutesRedirectGuard],
            data: { openedPage: { pageName: 'RegimenPlainInfoPage' } } },
        ],
      },
      {
        path: 'address',
        children: [
          { path: '', component: UserAddressListComponent, data: { openedPage: { pageName: 'AddressPage' } } },
          { path: ':id/edit', component: UserAddressEditComponent, data: { openedPage: { pageName: 'AddressEditPage' } } },
          { path: 'new', component: UserAddressEditComponent, data: { openedPage: { pageName: 'AddressNewPage' } } },
        ],
      },
      { path: 'addresses', component: UserAddressListComponent, data: { openedPage: { pageName: 'AddressesPage' } } },
      { path: 'report/:id', component: UserFollowupReportComponent, data: { openedPage: { pageName: 'ReportIdPage' } } },
      {
        path: 'instantCheckups',
        children: [
          { path: '', component: CheckupListComponent, data: { openedPage: { pageName: 'InstantCheckupListPage' } } },
          { path: 'preview', redirectTo: '/instant-checkup/preview', pathMatch: 'full' },
        ],
      },
      {
        path: 'instantCheckup',
        children: [
          { path: '', component: SelectCheckupTypeComponent, data: { openedPage: { pageName: 'InstantCheckupPage' } } },
          { path: 'menu', component: SelectCheckupTypeComponent },
          { path: 'preview', component: CheckupPhotoInstructionComponent },
          { path: 'capture', component: CheckupCaptureComponent },
          { path: 'list', component: CheckupListComponent },
          { path: ':id', component: CheckupViewContainerComponent },
        ],
      },
      {
        path: 'orders',
        children: [
          { path: '', component: UserOrderListComponent, data: { openedPage: { pageName: 'OrdersListPage' } } },
          { path: 'success', component: UserOrderSuccessComponent, data: { openedPage: { pageName: 'OrdersListSuccessPage' } } },
          { path: 'failure', component: UserOrderFailureComponent, data: { openedPage: { pageName: 'OrdersListFailurePage' } } },
          { path: 'reorder', component: UserOrderReorderComponent, data: { openedPage: { pageName: 'OrdersListReorderPage' } } },
        ],
      },
      {
        path: 'order',
        children: [
          { path: '', component: UserOrderListComponent, data: { openedPage: { pageName: 'OrderPage' } } },
          { path: 'list', component: UserOrderListComponent, data: { openedPage: { pageName: 'OrderListPage' } } },
          { path: 'reorder', component: UserOrderReorderComponent, data: { openedPage: { pageName: 'OrderListReorderPage' } } },
          { path: 'success', component: UserOrderSuccessComponent, data: { openedPage: { pageName: 'OrderListSuccessPage' } } },
          { path: 'failure', component: UserOrderFailureComponent, data: { openedPage: { pageName: 'OrderListFailurePage' } } },
          { path: 'addon', component: UserOrderAddonComponent, data: { openedPage: { pageName: 'OrderAddOnPage' } } },
          { path: ':id/payment', component: UserOrderPaymentComponent, data: { openedPage: { pageName: 'OrderIdPaymentPage' } } },
          { path: ':id', component: UserOrderViewComponent, data: { openedPage: { pageName: 'OrderIdViewPage' } } },
        ],
      },
      { path: 'change-language', component: ChangeLanguagePageComponent, data: { openedPage: { pageName: 'ChangeLanguagePage' } } },
      { path: 'prescription', component: UserPrescriptionViewComponent, data: { openedPage: { pageName: 'PrescriptionPage' } } },
      { path: 'refer', component: UserReferComponent, data: { openedPage: { pageName: 'ReferPage' } } },
      {
        path: 'wallet',
        children: [
          { path: '', component: UserWalletViewComponent, data: { openedPage: { pageName: 'WalletViewPage' } } },
          { path: 'transactions', component: UserWalletTransactionsComponent, data: { openedPage: { pageName: 'WalletTransactionPage' } } },
        ],
      },
      {
        path: 'profile',
        children: [
          { path: '', component: UserProfileComponent, data: { openedPage: { pageName: 'ProfileViewPage' } } },
          { path: 'edit', component: UserProfileEditComponent, data: { openedPage: { pageName: 'ProfileEditPage' } } },
        ],
      },
      {
        path: 'recently-viewed',
        component: RecentlyViewedProductsComponent,
        data: {
          openedPage: { pageName: 'RecentlyViewedPage' },
          isFullPage: true
        },
      },
    ],
  }, {
    path: 'reminder/:id',
    canActivate: [authenticationGuard, onboardingGuard],
    component: ReminderFullPageComponent,
    outlet: 'reminder',
  }, {
    path: 'clinical-technology',
    canActivate: [authenticationGuard, onboardingGuard],
    component: ClinicalTechnologyComponent,
    data: { openedPage: { pageName: 'ClinicalTechnologyPage' } },
  }, {
    path: 'moneyback-guarantee',
    canActivate: [authenticationGuard, onboardingGuard],
    component: MoneybackGuaranteePageComponent,
    data: { openedPage: { pageName: 'MoneybackGuaranteePage' } },
  }, {
    path: 'review-order',
    canActivate: [authenticationGuard, onboardingGuard],
    component: ReviewOrderComponent,
    data: { openedPage: { pageName: 'ReviewOrderPage' } },
  },{
    path: 'submit-default-answers',
    canActivate: [authenticationGuard, onboardingGuard],
    component: SubmitDefaultAnswersComponent,
    data: { openedPage: { pageName: 'MoneybackGuaranteePage' } },
  }, {
    path: '**',
    canActivate: [authenticationGuard, onboardingGuard],
    redirectTo: '/',
  },
];

const declarations: any = [];

export { AppRoutes, declarations };
